/* eslint-disable better-mutation/no-mutation */
/**
 * Debounce function
 * Borrowed from underscore;
 */
export const debounce = <T extends (...args: Parameters<T>) => void>(
    func: T,
    wait: number,
    immediate: boolean = false
) => {
    let timeout: ReturnType<typeof setTimeout> | null;
    return function (...args: Parameters<T>) {
        const later = () => {
            timeout = null;
            if (!immediate) {
                func(...args);
            }
        };
        const callNow = immediate && !timeout;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
        if (callNow) {
            func(...args);
        }
    };
};
